import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { PopoverController } from "@ionic/angular";
import { TranslateService } from "@ngx-translate/core";
import { AppComponent } from "src/app/app.component";
import { AuthGoogleService } from "src/app/services/auth-google.service";
import { AuthService } from "src/app/services/auth.service";

@Component({
  selector: "app-user",
  templateUrl: "./user.component.html",
  styleUrls: ["./user.component.scss"],
})
export class UserComponent implements OnInit {
  options = [
    {
      text: this.translate.instant("profile"),
    },
    {
      text: this.translate.instant("settingPriv"),
    },
    {
      text: this.translate.instant("deleteAcount"),
    },
    {
      text: this.translate.instant("LogOut"),
    },
  ];

  constructor(
    private popoverController: PopoverController,
    private authService: AuthService,
    private router: Router,
    private translate: TranslateService,
    private authGoogleService: AuthGoogleService
  ) {}

  ngOnInit() {}

  userOptions(valor: number) {
    this.popoverController.dismiss();
    switch (valor) {
      case 0:
        this.profile();
        return;
      case 1:
        this.config();
        return;
      case 2:
        this.deleteAcount();
        return;
      case 3:
        this.logoutAction();
        return;
    }
  }

  logoutAction() {
    //this.navCtrl.navigateRoot('/login');
    this.authService.logout();
    this.authGoogleService.logoutGoogle();
  }

  config() {
    this.router.navigate(["/configuracion-privacidad"]);
  }

  profile() {
    this.router.navigate(["/profile"]);
  }
  deleteAcount() {
    this.router.navigate(["/delete-acount"]);
  }
}
